import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from '@sensei/pi-component';

const useFullScreenDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
        dialog: {
            left: 'auto !important',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        big: {
            width: '962px',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        medium: {
            width: '880px',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        large: {
            maxWidth: '1584px',
            width: '100%',
        },
        small: {
            width: '736px',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        close: {
            flex: 1,
            alignText: 'right',
        },
        dialogHeader: {
            flexDirection: 'row-reverse',
            position: 'relative',
            paddingRight: 0,
            backgroundColor: colors.WHITE,
        },
        dialogToolbar: {
            width: '100%',
        },
        closeButton: {
            marginLeft: 'auto',
        },
    }),
);

export default useFullScreenDialogStyles;
